import React from "react";

const APP_KEY_PREFIX = "gwrene_";
const PRESERVED_APP_KEYS = new Set(["gwrene_analytics_consent"]);
const RECOVERY_FLAG = "__gwrene_render_recovery_attempted";
const RECOVERY_BACKUP = "__gwrene_render_recovery_backup";

function getRecoverableAppKeys() {
  const keys = [];
  try {
    for (let index = 0; index < localStorage.length; index += 1) {
      const key = localStorage.key(index);
      if (key?.startsWith(APP_KEY_PREFIX) && !PRESERVED_APP_KEYS.has(key)) {
        keys.push(key);
      }
    }
  } catch {
    // If storage is blocked, there is nothing to clear.
  }
  return keys;
}

function backupAndClearPracticeData() {
  const backup = {};
  const keys = getRecoverableAppKeys();
  keys.forEach((key) => {
    try {
      backup[key] = localStorage.getItem(key);
      localStorage.removeItem(key);
    } catch {
      // Keep clearing the rest if one key is unavailable.
    }
  });
  try {
    sessionStorage.setItem(
      RECOVERY_BACKUP,
      JSON.stringify({ savedAt: new Date().toISOString(), values: backup }),
    );
  } catch {
    // Backup is helpful for debugging, not required for recovery.
  }
}

function resetPracticeDataAndReload() {
  backupAndClearPracticeData();
  window.location.reload();
}

export class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    console.error("Guitar With Rene render error", error);
    try {
      if (sessionStorage.getItem(RECOVERY_FLAG) !== "true") {
        sessionStorage.setItem(RECOVERY_FLAG, "true");
        backupAndClearPracticeData();
        window.location.reload();
      }
    } catch {
      // Fall through to the visible recovery screen.
    }
  }

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    return (
      <main className="app-error-fallback" role="alert">
        <div>
          <span>Guitar With Rene</span>
          <h1>Let&apos;s refresh your practice data.</h1>
          <p>
            This browser saved something that did not load cleanly. Your account,
            login and Pro access are safe.
          </p>
          <div>
            <button type="button" onClick={() => window.location.reload()}>
              Try again
            </button>
            <button type="button" onClick={resetPracticeDataAndReload}>
              Refresh practice data
            </button>
          </div>
        </div>
      </main>
    );
  }
}
